export const MAX_DECIMAL = 8;
  


// WEBPACK FOOTER //
// ./src/components/common/Configurations/DecimalConfiguration.js